module.exports = __webpack_public_path__ + "static/media/extra-small.3c6f46f5.svg";